import React from 'react';
import { LinkedinIcon, TwitterIcon, GithubIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-[#0B1F15] text-white" data-id="element-530">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20" data-id="element-531">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10 lg:gap-12" data-id="element-532">
          <div className="col-span-2 md:col-span-1" data-id="element-533">
            <img src="https://cdn.magicpatterns.com/uploads/jGYrssm7tbfxt25FxeAxXx/CARBONSAFELOGO.png" alt="CarbonSafe" className="h-8 w-auto brightness-0 invert" data-id="element-534" />
            <p className="mt-4 text-sm text-white/50 leading-relaxed" data-id="element-535">
              Carbon intelligence for a sustainable future.
            </p>
          </div>
          <div data-id="element-536">
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-4" data-id="element-537">
              Product
            </h3>
            <ul className="space-y-3" data-id="element-538">
              <li data-id="element-539">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-540">
                  Emissions Tracking
                </a>
              </li>
              <li data-id="element-541">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-542">
                  Compliance
                </a>
              </li>
              <li data-id="element-543">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-544">
                  Carbon Offsets
                </a>
              </li>
              <li data-id="element-545">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-546">
                  Data Explorer
                </a>
              </li>
              <li data-id="element-547">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-548">
                  API
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-549">
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-4" data-id="element-550">
              Resources
            </h3>
            <ul className="space-y-3" data-id="element-551">
              <li data-id="element-552">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-553">
                  Documentation
                </a>
              </li>
              <li data-id="element-554">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-555">
                  Blog
                </a>
              </li>
              <li data-id="element-556">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-557">
                  Case Studies
                </a>
              </li>
              <li data-id="element-558">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-559">
                  Methodology
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-560">
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-4" data-id="element-561">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-562">
              <li data-id="element-563">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-564">
                  About
                </a>
              </li>
              <li data-id="element-565">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-566">
                  Careers
                </a>
              </li>
              <li data-id="element-567">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-568">
                  Contact
                </a>
              </li>
              <li data-id="element-569">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-570">
                  Partners
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-571">
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-4" data-id="element-572">
              Legal
            </h3>
            <ul className="space-y-3" data-id="element-573">
              <li data-id="element-574">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-575">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-576">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-577">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-578">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-579">
                  Cookie Policy
                </a>
              </li>
              <li data-id="element-580">
                <a href="#" className="text-sm text-white/70 hover:text-carbon-bright transition-colors" data-id="element-581">
                  Security
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-582">
          <p className="text-sm text-white/40" data-id="element-583">
            © 2026 CarbonSafe. All rights reserved.
          </p>
          <div className="flex items-center gap-4" data-id="element-584">
            <a href="#" className="text-white/40 hover:text-carbon-bright transition-colors" aria-label="LinkedIn" data-id="element-585">
              <LinkedinIcon className="w-5 h-5" data-id="element-586" />
            </a>
            <a href="#" className="text-white/40 hover:text-carbon-bright transition-colors" aria-label="Twitter" data-id="element-587">
              <TwitterIcon className="w-5 h-5" data-id="element-588" />
            </a>
            <a href="#" className="text-white/40 hover:text-carbon-bright transition-colors" aria-label="GitHub" data-id="element-589">
              <GithubIcon className="w-5 h-5" data-id="element-590" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}